import {authentication} from '@/store/modules/authentication';
import {notifications} from '@/store/modules/notifications';
import {spinner} from '@/store/modules/spinner';
import {profile} from '@/store/modules/profile';
import {modal} from '@/store/modules/modalWindow';
import {children} from '@/store/modules/children';
import {confirmModal} from '@/store/modules/confirmModal';
import {activities} from '@/store/modules/activities';
import {login} from '@/store/modules/login';
import {pageOptions} from '@/store/modules/pageOptions';
import {shoppingCart} from '@/store/modules/shoppingCart';
import {receipts} from '@/store/modules/receipts';
import {calendar} from '@/store/modules/calendar';
import {customForm} from '@/store/modules/customForm';
import {payment} from '@/store/modules/payment';

export const modules = {
    authentication,
    notifications,
    spinner,
    profile,
    modal,
    children,
    confirmModal,
    activities,
    pageOptions,
    login,
    shoppingCart,
    receipts,
    calendar,
    customForm,
    payment
};


// WEBPACK FOOTER //
// ./src/store/modules/index.js